<template>
  <span class="post-time">
    {{ formattedTime }}
  </span>
</template>

<script>
import { DateTimeUtil } from '../../../shared/utils/dateTimeUtil';
import { textUtil } from '../../../shared/utils/textUtil';

export default {
  props: {
    time: { type: String, default: '' },
    variation: { type: String, default: 'short' },
    isCapitalized: { type: Boolean, default: false },
  },
  computed: {
    formattedTime() {
      const timeVariation =
        this.variation === 'short'
          ? DateTimeUtil.shortDate(this.time, true)
          : DateTimeUtil.longDate(this.time, true, true);
      return this.isCapitalized ? this.capitalize(timeVariation) : timeVariation;
    },
  },
  methods: {
    capitalize(time) {
      return textUtil.upperFirst(time);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.post-time {
  font-size: 0.75rem;
}
</style>
